import { render, staticRenderFns } from "./InfoContainer.vue?vue&type=template&id=7b101f16&functional=true&"
import script from "./InfoContainer.vue?vue&type=script&lang=js&"
export * from "./InfoContainer.vue?vue&type=script&lang=js&"
import style0 from "./InfoContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports